// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"201":"media","594":"about","854":"menu","996":"franchise"}[chunkId] || chunkId) + "." + {"39":"35947605","201":"20da0d3a","466":"b9339f4e","594":"e7aeb6eb","854":"7885537e","996":"b723ace1"}[chunkId] + ".css";
};